module.exports = __webpack_public_path__ + "static/img/collection_onboarding.d8a9c383.svg";